import { Backdrop, Box, Button, CircularProgress, Dialog, IconButton, InputAdornment, Stack, TableCell, TextField, Typography, Snackbar, MenuItem } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Context } from "../App";
import { API, categories} from "../conf";
import { Close, Delete, Edit, BadgeOutlined, MailOutlined, Search, QrCode2Outlined } from "@mui/icons-material";
import xlsx from 'json-as-xlsx';
import Papa from 'papaparse';
import SorTableCheckable from "./sortable-checkable";
import DelegueForm from "./delegue-form";
import EditDeleguesForm from "./editDeleguesForm";
import Header from "./Header";
import Import from "./import";
import QRCode from 'qrcode';
import pdfMake from 'pdfmake/build/pdfmake';
import { badgeContent, badges, listDelegues, QrCode } from "../asset/pdfmaker";
import vfs from "pdfmake/build/vfs_fonts";

pdfMake.vfs = vfs;

export default function Delegues() {
    const input_file_ref = React.createRef()
    const mails = [{label:'Document', action:ids=>handleSendDoc(ids)}, {label:'Transport', action:ids=>handleSendTransport(ids)}, {label:'Rappel', action:ids=>handleSendRappel(ids)}, {label:'Personnalisé', action:ids=>manage_dialog(true, 'edit courriel')}]
    const {updateConnect} = useContext(Context)
    const [load, setLoad] = useState(true)
    const [imported, setImported] = useState(<Import/>)
    const [delegues, setDelegues] = useState([])
    const [search, setShearch] = useState('')
    const [selectItems, setItems] = useState([])
    const [delegue, setDelegue] = useState()
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('')
    const [open_snack, setsnack] = useState(false)
    const [snack_msg, setsnack_msg] = useState('')
    const [mailType, setMail] = useState('')
    const [pdf, setPdf] = useState()
    const [filter, setFilter] = useState('')

    const table = [
        {header: "Catégorie", sortable: true, sortBy:(el)=>el.categorie, row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.categorie}</TableCell>},
        {header: "Genre", sortable: true, sortBy:(el)=>el.genre, row: (row, index)=><TableCell key={index}>{row.genre}</TableCell>},
        {header: "Nom", sortable: true, sortBy:(el)=>el.nom.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.nom}</TableCell>},
        {header: "Prénoms", sortable: true, sortBy:(el)=>el.prenoms.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.prenoms}</TableCell>},
        {header: "Mail", sortable: true, sortBy:(el)=>el.mail, row: (row, index)=><TableCell key={index}>{row.mail}</TableCell>},
        {header: "Téléphone", sortable: true, sortBy:(el)=>el.tel??'', row: (row, index)=><TableCell key={index}>{row.tel??''}</TableCell>},
        {header: "Repas", sortable: true, sortBy:el=>el.repas.reduce((tt, item)=>tt+item.count,0), row: (row, index)=><TableCell key={index} style={{minWidth:'120px', whiteSpace:'break-spaces'}}>{row.repas.map(repas=>repas.repas+': '+repas.count).join('\n')}</TableCell>},
        {header: "Transport", sortable: true, sortBy:el=>el.transport?0:1, row: (row, index)=><TableCell key={index} align="center" style={{maxWidth:'70px', whiteSpace:'break-spaces', fontWeight:row.transport?'bold':'normal', color:row.transport?'green':'black'}}>{row.transport?'oui':'non'}</TableCell>},
        {header: "", sortable: false, row: (row, index)=><TableCell key={index} align="right" sx={{minWidth:'200px'}} >
            <IconButton aria-label="badge" onClick={()=>{showBadges([row])}}><BadgeOutlined fontSize="small"/></IconButton>
            <IconButton aria-label="qrcode" onClick={()=>showQRcodeVote([row])}><QrCode2Outlined fontSize="small"/></IconButton>
            <IconButton aria-label="mail" onClick={()=>{setDelegue(row); manage_dialog(true, 'mail')}}><MailOutlined fontSize="small"/></IconButton>
            <IconButton aria-label="modifier" onClick={()=>{setDelegue(row); manage_dialog(true, 'edit')}}><Edit fontSize="small"/></IconButton>
            <IconButton aria-label="supprimer" onClick={()=>{setDelegue(row); manage_dialog(true, 'delete')}}><Delete fontSize="small"/></IconButton>
        </TableCell>}
    ]

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(item) {
        return item.nom+' '+item.prenoms+' '+item.mail+' '+(item.tel??'')
    }

    function manage_dialog(status, action) {
        setOpen(status); setAction(action)
        setMail(''); setImported(<Import/>)
        if (!status) {
            setDelegue()
        } 
    }

    async function PDFBadgeGenerator(selectedDelegues) {return new Promise((resolve, reject) => {
        Promise.all(selectedDelegues.map(async(dlg,index) => {
            const qr = await QRCode.toDataURL(dlg._id)
            return{...dlg, qr}
        })).then((deleguesWithQr)=> {
            const pdfDocGenerator = pdfMake.createPdf(badges(deleguesWithQr));
            pdfDocGenerator.getBlob((blob) => {
                const url = URL.createObjectURL(blob);
                resolve(url)
            });
        })
    })}

    async function PDFQRcodeGenerator(selectedDelegues) {return new Promise((resolve, reject) => {
        Promise.all(selectedDelegues.map(async(dlg,index) => {
            const qr = await QRCode.toDataURL(encodeURIComponent(dlg.nom.toUpperCase() + ' ' + dlg.prenoms),{ errorCorrectionLevel: "H" })
            const badge1 = QrCode(dlg, qr, 'green', 'OUI')
            const badge2 = QrCode(dlg, qr, 'red', 'NON')
            return index<selectedDelegues.length-1 ? [...badge1, {text:'', pageBreak: 'after'}, ...badge2, {text:'', pageBreak: 'after'}] : [...badge1, {text:'', pageBreak: 'after'}, ...badge2]
        })).then((badges)=> {
            const pdfDocGenerator = pdfMake.createPdf({
                pageSize: 'A5',
                pageMargins: [20, 20, 20, 30],
                content: badges,
            });
            pdfDocGenerator.getBlob((blob) => {
                const url = URL.createObjectURL(blob);
                resolve(url)
            });
        })
    })}

    async function exportPDF(selectedDelegues) {
        setLoad(true)
        Promise.all(selectedDelegues.map(async(dlg,index) => {
            const qr = await QRCode.toDataURL(dlg._id)
            return{...dlg, qr}
        })).then((deleguesWithQr)=> {
            const pdfDocGenerator = pdfMake.createPdf(listDelegues(deleguesWithQr));
            pdfDocGenerator.getBlob((blob) => {
                const url = URL.createObjectURL(blob);
                setPdf(url)
                manage_dialog(true, 'pdf')
                setLoad(false)
            });
        })
    }

    async function showBadges(selectedDelegues) {
        setLoad(true)
        PDFBadgeGenerator(selectedDelegues).then(pdf_url=>{
            setPdf(pdf_url)
            manage_dialog(true, 'pdf'); setLoad(false)
        }).catch(err=>{console.log(err); setLoad(false)})
    }

    async function showQRcodeVote(selectedDelegues) {
        setLoad(true)
        PDFQRcodeGenerator(selectedDelegues).then(pdf_url=>{
            setPdf(pdf_url)
            manage_dialog(true, 'pdf'); setLoad(false)
        }).catch(err=>{console.log(err); setLoad(false)})
    }

    function printBadges(selectedDelegues) {
        setLoad(true)
        PDFBadgeGenerator(selectedDelegues).then(pdf_url=>{
            const win = window.open(pdf_url, '_blank');
            if (win) {
                win.onload = () => win.print();
            } else {
                alert('Impossible d\'ouvrir le PDF et de l\'imprimer');
            }
            setLoad(false)
        })
    }

    function printQRcode(selectedDelegues) {
        setLoad(true)
        PDFQRcodeGenerator(selectedDelegues).then(pdf_url=>{
            const win = window.open(pdf_url, '_blank');
            if (win) {
                win.onload = () => win.print();
            } else {
                alert('Impossible d\'ouvrir le PDF et de l\'imprimer');
            }
            setLoad(false)
        })
    }

    async function handleDelete(ids) {
        setLoad(true)
        fetch(API.concat(`/Delegue/by/${JSON.stringify({_id:{$in:ids}})}`), {method:'DELETE', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', token)
                }
                if (response.status === 204) {
                    setDelegues(old=> old.filter(usr=>!ids.includes(usr._id)))
                    manage_dialog(false, '')
                } setLoad(false)
            }
        })
    }

    async function handleSendDoc(ids) {
        setLoad(true)
        manage_dialog(false, '')
        fetch(API.concat(`/delegue/${JSON.stringify({_id:{$in:ids}})}/senddoclink`), {method:'POST', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    setsnack_msg('Les liens ont été envoyés avec succès')
                    setsnack(true)
                } setLoad(false)
            }
        })
    }

    async function handleSendTransport(ids) {
        setLoad(true)
        manage_dialog(false, '')
        fetch(API.concat(`/delegue/${JSON.stringify({_id:{$in:ids}})}/sendtransportmail`), {method:'POST', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    setsnack_msg('Les liens ont été envoyés avec succès')
                    setsnack(true)
                } setLoad(false)
            }
        })
    }

    function handleSendRappel(ids) {
        setLoad(true)
        manage_dialog(false, '')
        fetch(API.concat(`/delegue/${JSON.stringify({_id:{$in:ids}})}/sendrappelmail`), {method:'POST', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    setsnack_msg('Les mails de rappels ont été envoyés avec succès')
                    setsnack(true)
                } setLoad(false)
            }
        })
    }

    function handleImport(event) {
        event.preventDefault();
        setLoad(true)

        let userFile = event.target.files[0];

        Papa.parse(userFile, {
            header: true,
            complete: function(results) {
                let imported = results.data
                let headers = Object.keys(imported[0])
                console.log(headers)
                setLoad(false)
                manage_dialog(true, 'import')

                if (headers && ['genre', 'nom', 'prenoms', 'mail', 'categorie'].every(header => headers.includes(header))) {
                    setImported(<Import users={imported} updateData={setDelegues} old={delegues} close={()=>manage_dialog(false, '')} />)
                } else {
                    setImported(<Import msg='Entêtes invalides!' close={()=>manage_dialog(true, 'import')}/>);
                }
            }
        })
    }

    function handleExport(data) {
        let excel = [
            {
              sheet: "Inscription transport",
              columns: [
                { label: "Catégorie", value: (row) => row.categorie }, 
                { label: "Genre", value: (row) => row.genre }, 
                { label: "Nom", value: row => row.nom.toUpperCase() }, 
                { label: "Prénoms", value: row => row.prenoms.split(' ').map(prenom=>prenom.charAt(0).toUpperCase()+prenom.slice(1)).join(' ') }, 
                { label: "Mail", value: row=> row.mail }, 
                { label: "Téléphone", value: row=> row.tel }, 
              ],
              content: data,
            },
        ]
          
        let settings = {
            fileName: `Transport_AGO2025_${Date.now().toLocaleString()}`, // Name of the resulting spreadsheet
            extraLength: 3, // A bigger number means that columns will be wider
            writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
            writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
        }
          
        xlsx(excel, settings) // Will download the excel file
    }

    useEffect(()=>{
        fetch(API.concat('/Delegue/all'), {method:'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setDelegues(json); setLoad(false)
                }else setLoad(false)
            }
        })
    },[updateConnect]) 

    return(
        <Box display='flex' flex={1} flexDirection='column' marginBottom='30px'>
            <Header/>
            <Typography variant="h4" align="center" marginY={5}>Gestion des délégués</Typography>
            <Box display='flex' justifyContent='space-between' alignItems='center' marginX='30px'>
                <Stack direction='row' spacing={2} alignSelf='end' alignItems='center' marginBottom={2}>
                    <TextField select size="small" label="Filtres" value={filter} onChange={e=>setFilter(e.target.value)} slotProps={{select: {native: true}, inputLabel:{shrink: true}}}>
                        <option value=''>Tous</option>
                        <option value='blanc'>Badge blancs</option>
                        <option value='bleu'>Badge bleu</option>
                        <option value='noir'>Badge noirs</option>
                        {categories.map(cat=> <option key={cat} value={normalize(cat)}>{cat}</option>)}
                    </TextField>
                    <Button variant="contained" disabled={selectItems.length<1} onClick={()=>exportPDF(delegues.filter(dlg=>selectItems.includes(dlg._id)))}>Export pdf</Button>
                    <Button variant="contained" disabled={selectItems.length<1} onClick={()=>showBadges(delegues.filter(dlg=>selectItems.includes(dlg._id)))}>badges</Button>
                    <Button variant="contained" disabled={selectItems.length<1} onClick={()=>printQRcode(delegues.filter(dlg=>selectItems.includes(dlg._id)))}>QR code vote</Button>
                    <Button variant="contained" disabled={selectItems.length<1} onClick={()=>manage_dialog(true, 'mail many')}>Envoyer mail</Button>
                </Stack>
                <Stack direction='row' spacing={2} alignSelf='end' alignItems='center' marginX='30px' marginBottom={2}>
                    <Button variant="outlined" onClick={()=>handleExport(delegues.filter(dlg=>dlg.transport))}>exporter liste transport</Button>
                    <Typography variant="h6" align="right" fontWeight='bold' marginY={2} marginX='30px'>Inscription transport: {delegues.filter(dlg=>dlg.transport).length}/35</Typography>
                </Stack>
            </Box>
            <Box display='flex' justifyContent='space-between' alignItems='center' marginX='30px'>
                <TextField placeholder="Rechercher un délégué" size="small" sx={{width:'60%', minWidth:'400px'}} value={search} onChange={e=>setShearch(e.target.value)}
                InputProps={{endAdornment: (<InputAdornment position="end"><Search /></InputAdornment>)}}/>
                <Stack direction='row' spacing={1} alignItems='center'>
                    <input type='file' name='delegues_file' accept='.csv' ref={input_file_ref} hidden onChange={(event)=>{handleImport(event)}} />
                    <Button variant="contained" onClick={()=> input_file_ref.current.click()}>Importer</Button>
                    <Button variant="contained" onClick={()=>manage_dialog(true, 'add')}>Ajouter</Button>
                    <Button variant="contained" disabled={selectItems.length<1} onClick={()=>manage_dialog(true, 'edit-many')}>Modifier</Button>
                    <Button variant="contained" disabled={selectItems.length<1} onClick={()=>manage_dialog(true, 'delete many')}>supprimer</Button>
                </Stack>
            </Box>

            <div style={{marginInline:'30px'}}><SorTableCheckable data={delegues.filter(item=> (filter!==''? normalize(item.categorie) === filter : true) && normalize(get_searchable(item)).includes(normalize(search)))} selectItems={selectItems} setItems={setItems} table={table} rowsPerPage={100} rowsPerPageOptions={[50, 100, 300]}/></div>

            <Snackbar
            open={open_snack}
            autoHideDuration={5000}
            onClose={()=> setsnack(false)}
            message={snack_msg}
            />

            <Backdrop open={load}><CircularProgress/></Backdrop>
            <Dialog open={open} fullWidth maxWidth={action==='import'?'lg':['add', 'edit', 'pdf'].includes(action)?'md':'xs'} onClose={()=>manage_dialog(false, '')}>
                <IconButton onClick={()=>manage_dialog(false, '')} sx={{alignSelf:'end', marginTop:'5px', marginRight:'5px'}}><Close/></IconButton>
                {action==='add'&& <DelegueForm {...{add:usr=>setDelegues(old=>[...old, usr]), close:()=>manage_dialog(false, '')}} />}
                {action==='import'&& imported}
                {action==='edit'&&delegue&& <DelegueForm {...{edit:true, delegue, add:usr=>setDelegues(old=>[...old.filter(u=>u._id!==usr._id), usr]), close:()=>manage_dialog(false, '')}} />}
                {action==='edit-many'&& <EditDeleguesForm {...{delegues: delegues.filter(d=>selectItems.includes(d._id)), update:dlgs=>setDelegues(old=>old.map(d=>dlgs?.find(dl=> dl._id===d._id)||d)), close:()=>manage_dialog(false, '')}} />}
                {action==='pdf' && pdf &&<Box sx={{marginInline:2}}><embed src={pdf} width='100%' height='600px' type="application/pdf" /></Box>}
                {action.includes('mail')&&<Box display='flex' flexDirection='column' paddingInline={1} paddingBottom={1}>
                    <Typography fontWeight={600} fontSize={18} align="center">Envoyer mail :</Typography>
                    <TextField select label="Type de mail" value={mailType} onChange={e=>setMail(e.target.value)} sx={{width:'100%', marginTop:'10px'}}>
                        {mails.map((item, index)=><MenuItem key={index} value={item.label}>{item.label}</MenuItem>)}
                    </TextField>
                    <Typography fontWeight={600} fontSize={18} align="center" marginTop={1.5}>à {action==='mail'?[delegue.nom, delegue.prenoms].join(' '):`${selectItems.length} délégué${selectItems.length>1?'s':''}`}</Typography>
                    <Stack direction='row' spacing={2} marginTop={2} alignItems='center' alignSelf='end'>
                        <Button variant="outlined"  onClick={()=>manage_dialog(false,'')}>annuler</Button>
                        <Button variant="contained" color="primary" disabled={!mailType||mailType===''} onClick={()=>mails.find(ml=>ml.label===mailType).action(action==='mail'?[delegue._id]:selectItems)}>{mailType==='Personnalisé'?'créer mail':'envoyer'}</Button>
                    </Stack>
                </Box>}                
                {action==='delete'&&<Box display='flex' flexDirection='column' paddingInline={1} paddingBottom={1}>
                    <Typography fontWeight={600} fontSize={18} align="center" textTransform='capitalize'>Supprimer {[delegue.nom, delegue.prenoms].join(' ')}</Typography>
                    <Stack direction='row' spacing={2} marginTop={2} alignItems='center' alignSelf='end'>
                        <Button variant="outlined"  onClick={()=>manage_dialog(false,'')}>annuler</Button>
                        <Button variant="contained" color="carmine" onClick={()=>handleDelete([delegue._id])}>supprimer</Button>
                    </Stack>
                </Box>}
                {action==='delete many'&&<Box display='flex' flexDirection='column' paddingInline={1} paddingBottom={1}>
                    <Typography fontWeight={600} fontSize={18} align="center">Supprimer {selectItems.length} délégués{selectItems.length>1&&'s'}</Typography>
                    <Stack direction='row' spacing={2} marginTop={2} alignItems='center' alignSelf='end'>
                        <Button variant="outlined"  onClick={()=>manage_dialog(false,'')}>annuler</Button>
                        <Button variant="contained" color="carmine" onClick={()=>handleDelete(selectItems)}>supprimer</Button>
                    </Stack>
                </Box>}
                {action==='edit courriel'&&<Box display='flex' flexDirection='column' paddingInline={1} paddingBottom={1}></Box>}
            </Dialog>
        </Box>
    )
}